// @ts-nocheck
import React from 'react';
import { ApplyPluginsType, dynamic } from '/home/jenkins/workspace/BUILD_NODE_IMAGE_TMP/node_modules/umi/node_modules/@umijs/runtime';
import * as umiExports from './umiExports';
import { plugin } from './plugin';
import LoadingComponent from '@ant-design/pro-layout/es/PageLoading';

export function getRoutes() {
  const routes = [
  {
    "path": "/",
    "exact": true,
    "redirect": "/login"
  },
  {
    "path": "/login",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__LoginLayout' */'@/layouts/LoginLayout'), loading: LoadingComponent}),
    "routes": [
      {
        "path": "/login",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Login' */'@/pages/Login'), loading: LoadingComponent})
      }
    ]
  },
  {
    "path": "/register",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__LoginLayout' */'@/layouts/LoginLayout'), loading: LoadingComponent}),
    "routes": [
      {
        "path": "/register",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Register' */'@/pages/Register'), loading: LoadingComponent})
      }
    ]
  },
  {
    "path": "/center",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__CenterLayout' */'@/layouts/CenterLayout'), loading: LoadingComponent}),
    "routes": [
      {
        "path": "/center/baseInfo",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__My__BasrInfo' */'@/pages/My/BasrInfo'), loading: LoadingComponent})
      },
      {
        "path": "/center/resetPassword",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__My__ResetPassword' */'@/pages/My/ResetPassword'), loading: LoadingComponent})
      },
      {
        "path": "/center/userLogout",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__My__UserLogout' */'@/pages/My/UserLogout'), loading: LoadingComponent})
      },
      {
        "path": "/center/phoneSetting",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__My__PhoneSetting' */'@/pages/My/PhoneSetting'), loading: LoadingComponent})
      },
      {
        "path": "/center/emailSetting",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__My__EmailSetting' */'@/pages/My/EmailSetting'), loading: LoadingComponent})
      },
      {
        "redirect": "/center/baseInfo",
        "exact": true
      }
    ]
  }
];

  // allow user to extend routes
  plugin.applyPlugins({
    key: 'patchRoutes',
    type: ApplyPluginsType.event,
    args: { routes },
  });

  return routes;
}
